import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/ui/docs-site/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
/*-- dri: Alexa Kreizinger --*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Install Core Agent on macOS";
const frontMatter = {
  "title": "Install Core Agent on macOS",
  "description": "Learn how to install Core Agent on macOS"
};
export function useTOC(props) {
  return [{
    value: "Supported architectures",
    id: "supported-architectures",
    depth: 2
  }, {
    value: "Dependencies",
    id: "dependencies",
    depth: 2
  }, {
    value: "Install",
    id: "install",
    depth: 2
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    li: "li",
    mark: "mark",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <>{}{"\n"}<_components.h1>{"Install Core Agent on macOS"}</_components.h1>{"\n"}<_components.p>{"In Chronosphere Telemetry Pipeline, you can use "}<_components.a href="/fleets">{"fleets"}</_components.a>{" to manage instances\nof Core Agent. Use this guide to install Core Agent on macOS."}</_components.p>{"\n"}<_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.p>{"Core Agent supports both x86-64 and Apple Silicon M1 architectures."}</_components.p>{"\n"}<_components.h2 id={toc[1].id}>{toc[1].value}</_components.h2>{"\n"}<_components.p>{"For macOS installations, Core Agent has the following general dependencies:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li>{"libc"}</_components.li>{"\n"}<_components.li>{"libsasl"}</_components.li>{"\n"}<_components.li>{"libsystemd"}</_components.li>{"\n"}<_components.li>{"libyaml"}</_components.li>{"\n"}<_components.li>{"OpenSSL"}</_components.li>{"\n"}<_components.li>{"zlib"}</_components.li>{"\n"}</_components.ul>{"\n"}<_components.h2 id={toc[2].id}>{toc[2].value}</_components.h2>{"\n"}<_components.p>{"Use these steps to install Core Agent:"}</_components.p>{"\n"}<_components.ol>{"\n"}<_components.li>{"\n"}<_components.p>{"Either download the latest "}<_components.code>{".pkg"}</_components.code>{" file from the\n"}<_components.a href="https://calyptia-lts-release-standard.s3.amazonaws.com/index.html">{"Core Agent downloads page"}</_components.a>{",\nor run the following command:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"wget"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" https://calyptia-lts-release-standard.s3.amazonaws.com/macos/"}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"VERSION"}</_components.span></_components.mark><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"/calyptia-fluent-bit-"}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"VERSION"}</_components.span></_components.mark><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"-apple.pkg"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Replace both instances of "}<_components.em><_components.code>{"VERSION"}</_components.code></_components.em>{" with the\n"}<_components.a href="/fleets/agent/version-equivalents">{"latest version of Core Agent"}</_components.a>{"."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Run the following command to install Core Agent:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"sudo"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" installer"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -pkg"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" calyptia-fluent-bit-"}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"VERSION"}</_components.span></_components.mark><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"-apple.pkg"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -target"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" /usr/local/bin/"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Replace "}<_components.em><_components.code>{"VERSION"}</_components.code></_components.em>{" with the\n"}<_components.a href="/fleets/agent/version-equivalents">{"latest version of Core Agent"}</_components.a>{"."}</_components.p>{"\n"}</_components.li>{"\n"}<_components.li>{"\n"}<_components.p>{"Run the following command to test whether your installation was successful:"}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap="" data-copy=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"calyptia-fluent-bit"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -i"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" dummy"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -o"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" stdout"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -f"}</_components.span><_components.span style={{
    "--shiki-dark": "#F5A97F",
    "--shiki-light": "#1976D2"
  }}>{" 1"}</_components.span></_components.span></_components.code></_components.pre>{"\n"}</_components.li>{"\n"}</_components.ol></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/fleets/agent/macos-install',
  {"filePath":"pages/fleets/agent/macos-install.mdx",pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)